import * as Plot from "@observablehq/plot";
import { useEffect, useRef } from 'react'

const aMonthAgo = () => {
  const d = new Date()
  d.setDate(d.getDate() - 30);
  return d
}

function NyindlagtePlotMini({ nyindlagte }) {
  const ref = useRef(null);

  useEffect(() => {
    const plot = Plot.plot({
      y: {
        grid: true,
        label: null
      },
      marks: [
        Plot.line(
          nyindlagte.filter((d) => d.date > aMonthAgo()).sort((a, b) => a.date - b.date),
          { x: "date", y: "newHospitalized", stroke: "steelblue" }
        ),
        Plot.ruleY([0])
      ],
      width: 280,
      height: 175
    });
    if (ref.current) {
      if (ref.current.children[0]) {
        ref.current.children[0].remove();
      }
      ref.current.appendChild(plot);
    }
  }, [ref, nyindlagte]);
  return (
    <div style={{ display: "flex", justifyContent: "center" }} ref={ref} />
  )
}

export default NyindlagtePlotMini